export const ipoIncludedValues = ['IPO', 'IPO_SPAC', 'DIRECT_LISTING'];
export const followOnIncludedValues = ['MARKETED_FO', 'OVERNIGHT_FO', 'ABB', 'UNDERWRITTEN_RD'];
export const blockIncludedValues = ['REGISTERED_BLOCK', 'UNREGISTERED_BLOCK'];
export const convertibleIncludedValues = ['CONVERTIBLE'];
export const rightsIncludedValues = ['RIGHTS'];

export function getOfferingTypeOptionsTree(offeringTypeOptions: any) {
  const ipoOptions = offeringTypeOptions.filter(option => ipoIncludedValues.includes(option.value));

  const followOnOptions = offeringTypeOptions.filter(option =>
    followOnIncludedValues.includes(option.value)
  );

  const blockOptions = offeringTypeOptions.filter(option =>
    blockIncludedValues.includes(option.value)
  );

  const convertibleOptions = offeringTypeOptions.filter(option =>
    convertibleIncludedValues.includes(option.value)
  );

  const rightsOptions = offeringTypeOptions.filter(option =>
    rightsIncludedValues.includes(option.value)
  );

  const offeringTypeOptionsTree = [
    ...(ipoOptions.length > 0
      ? [
          {
            label: 'IPO',
            value: 'ipos',
            children: ipoOptions,
          },
        ]
      : []),
    ...(followOnOptions.length > 0
      ? [
          {
            label: 'Follow-on',
            value: 'FOLLOW_ON',
            children: followOnOptions,
          },
        ]
      : []),
    ...(blockOptions.length > 0
      ? [
          {
            label: 'Block',
            value: 'blocks',
            children: blockOptions,
          },
        ]
      : []),
    ...(convertibleOptions.length > 0 ? [{ label: 'Convertible', value: 'CONVERTIBLE' }] : []),
    ...(rightsOptions.length > 0 ? [{ label: 'Rights', value: 'RIGHTS' }] : []),
  ];

  return { offeringTypeOptionsTree };
}
